<button (click)="showDialog($event)" *ngIf="user" [matBadge]="unreadNotificationsCount ? unreadNotificationsCount : ''" aria-label="Show messages"
        color="accent" i18n-aria-label="Show messages" mat-icon-button matBadgeColor="warn" matBadgePosition="after">
  <mat-icon>notifications</mat-icon>
</button>
